// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"d068caa6","105":"34e0ab33","349":"1e4d407c","574":"d4b62ba3"}[chunkId] + ".chunk.css";
};